import StreamPagination from './StreamPagination';
import StreamPaginationContainer from './StreamPagination.container';

export default StreamPaginationContainer(StreamPagination);
